import {createGlobalStyle} from 'styled-components';
import INGMeWebRegular from './INGMeWeb-Regular.woff';
import INGMeWebBold from './INGMeWeb-Bold.woff';

export const IngFonts = createGlobalStyle`
  @font-face {
    font-family: 'ING Me Web';
    src: url(${INGMeWebRegular}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'ING Me Web';
    src: url(${INGMeWebBold}) format('woff');
    font-weight: 700;
    font-style: normal;
  }
`;
